import React, { useEffect, useState } from 'react'
import Button from '../../atoms/Button/Button'
import Link from 'next/link'
import { Breadcrumbs, MetaSeo, Trans } from '../../../components/index'
import { STRUMENTISERVIZI } from '../../../utils/endpoint'
import { api } from '../../../utils'
import StrumentiServiziCard from '../../molecules/StrumentiServiziCard/StrumentiServiziCard'
import { useRouter } from 'next/router'
import { getAltText } from '../../../utils/safe'

const StrumentiServiziTemplate = ({ page }) => {
  const [strumentiServizi, setStrumentiServizi] = useState([])
  const router = useRouter()

  const listStrumentiServizi = async () => {
    api
      .get(STRUMENTISERVIZI, {
        params: {
          lang: router.locale,
        },
      })
      .then((response) => {
        setStrumentiServizi(response.data)
      })
      .catch((error) => console.log(error))
  }

  useEffect(() => {
    listStrumentiServizi()
  }, [])

  return (
    <div className="page strumenti_container">
      <div className="w-container">
        <MetaSeo seo={page?.seo || undefined} />
        <Breadcrumbs breadcrumbs={page?.breadcrumbs} />
        <h1 className="page__title">
          <Trans chiave="Strumenti e Servizi" />
        </h1>
        <div className="strumenti_container__header">
          <h2 className="strumenti_container__header__titolo">
            <Trans chiave="Con noi puoi" />
            {'...'}
          </h2>
          <br />
          <div className="strumenti_container__header__servizi-container">
            {strumentiServizi.map((strumento, index) => (
              <StrumentiServiziPoint key={index} strumento={strumento} />
            ))}
          </div>
        </div>
        {strumentiServizi.map((strumento, index) => (
          <StrumentiServiziCard key={index} index={index} strumento={strumento} />
        ))}
      </div>
    </div>
  )
}

export default StrumentiServiziTemplate

export const StrumentiServiziPoint = ({ strumento }) => {
  return (
    <div className="strumenti_container__header__servizi-container__servizi">
      <div className="strumenti_container__header__servizi-container__servizi__image-box">
        <img src={strumento?.immagine_small?.url} alt={getAltText(strumento?.immagine_small)} />
      </div>
      <div className="strumenti_container__header__servizi-container__servizi__description">
        <p>
          <Trans chiave={strumento.descrizione} />
        </p>
        <div className="strumenti_container__header__servizi-container__servizi__link">
          <Link legacyBehavior href={strumento.link ?? ''}>
            <Button
              href={strumento.link ?? ''}
              label={strumento.titolo + ' >'}
              size="medium"
              variant="ghost"
            />
          </Link>
        </div>
      </div>
    </div>
  )
}
